export enum EmployeeType {
  Opener = 'opener',
  Closer = 'closer',
  Owner = 'owner',
}
